const API_URL = process.env.REACT_APP_STRAPI_URL || 'https://strapi.wnt.rs';
const DEFAULT_OPTIONS = {
    headers: {
        'Authorization': process.env.REACT_APP_STRAPI_TOKEN || 'bearer f28e3a646dcad1a2bae5945f547e9d2d23764a6994047d056d203c47ccc85156b45445330235eac1f3d60e969b7ba8e4135b20902480d89582f4512cb8ba1cc59585f917d36bd81b5723c39c5f310ab6a8891f61f877071975e282588f89e3e34c21628bf95e3e485b54fe56ad7a48c03e8ae2d85c2e306fc31723e2e879e942'
    }
}

export async function fetchCollectives(locale) {

  const response = await fetch(`${API_URL}/api/collectives?populate=*&locale=${locale}`, DEFAULT_OPTIONS);

  const data = await response.json();

  return data.data;

}


export async function fetchCollective(locale, id) {

  const response = await fetch(`${API_URL}/api/collectives/${id}?populate=*&locale=${locale}`, DEFAULT_OPTIONS);

  const data = await response.json();

  return data.data;

}

export async function fetchWeeklySchedule(locale) {

  const response = await fetch(`${API_URL}/api/weekly-schedule?populate[0]=Monday.Events&populate[1]=Tuesday.Events&populate[2]=Wednesday.Events&populate[3]=Thursday.Events&populate[4]=Friday.Events&populate[5]=Saturday.Events&populate[6]=Sunday.Events&locale=${locale}`, DEFAULT_OPTIONS);

  const data = await response.json();

  return data.data;
}

export async function fetchAcquisitionFaq(locale) {
  const response = await fetch(`${API_URL}/api/acquisition-page?populate=*&locale=${locale}`, DEFAULT_OPTIONS);

  const data = await response.json();

  return data.data;
}

export function getImageUrl(url) {
  return API_URL + url
}

export async function fetchFundraiseProgress() {
  const response = await (fetch(`${API_URL}/api/acquisition-progress-bar?populate=*`, DEFAULT_OPTIONS));

  const data = await response.json();

  return data.data
}

export async function getBlogs(locale) {
    const response = await fetch(`${API_URL}/api/winters-blog-news?populate=*`, DEFAULT_OPTIONS);

    const data = await response.json();

    return data.data;
}

export async function getBlog(id, locale) {
  const response = await fetch(`${API_URL}/api/winters-blog-news/${id}?populate[blog][on][shared.image][populate][0]=image&populate[blog][on][shared.blog-text][populate]=*`, DEFAULT_OPTIONS)

  const data = await response.json();

  return data.data;
}